angular.module('tf.services')

    .factory('CloudinaryUploadService',['Upload','cloudinary','$q',function($upload, cloudinary, $q){
        var service = {};

        service.upload = function(file, progress){
            var defer = $q.defer();
            if (file && !file.$error) {
                file.upload = $upload.upload({
                    url: "https://api.cloudinary.com/v1_1/" + cloudinary.config().cloud_name + "/upload",
                    data: {
                        upload_preset: cloudinary.config().upload_preset,
                        //tags: 'myphotoalbum',
                        //context: 'photo=' + $scope.title,
                        file: file
                    }
                })
                .progress(function(e){
                    if(progress){
                        progress(e);
                    }
                })
                .success(function(data){
                    defer.resolve(data);
                })
                .error(function(data){
                    defer.reject(data);
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        return service;
    }])

;
